Ext.define('SA.ViewControllerModeState', {
    statics: {
        forViewMode({controller}) {
            return new SA.ViewControllerModeState({controller, mode: 'view'});
        }
    },

    constructor({controller, mode}) {
        this.mode = mode;
        this.observable = new Ext.util.Observable();

        this.listener = controller.on('setModeActive', this.onControllerSetModeActive, this, {destroyable: true});
    },

    destroy() {
        Ext.destroyMembers(this, 'listener');
    },

    isActive() {
        return this.active;
    },

    onActive(callback, scope) {
        this.observable.on('active', callback, scope);
    },

    onControllerSetModeActive({mode, active}) {
        if (mode !== this.mode) {
            return;
        }

        this.active = active;
        this.observable.fireEvent(active ? 'active' : 'inactive');
    },

    onInactive(callback, scope) {
        this.observable.on('inactive', callback, scope);
    }
});